import GlobalStyle from "./GlobalStyle";
import media from "./media";

export { media };
export default GlobalStyle;
